// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._shared_page__GtjvJ {
  width: 100%;
  min-height: 100%;
  background-color: var(--color-bg-subtle);
  padding-bottom: var(--sp-16);
}

._shared_hero__x3MN8 {
  position: relative;
  overflow: hidden;
  padding: var(--sp-16) var(--sp-10);
  background: radial-gradient(ellipse at 20% 30%, rgba(14, 165, 233, 0.1) 0%, transparent 55%), radial-gradient(ellipse at 80% 70%, rgba(139, 92, 246, 0.1) 0%, transparent 55%), linear-gradient(135deg, var(--color-bg) 0%, var(--color-bg-subtle) 100%);
  color: var(--color-text);
}

._shared_heroGridOverlay__Lm5sx {
  position: absolute;
  inset: 0;
  background-image: linear-gradient(rgba(15, 23, 42, 0.04) 1px, transparent 1px), linear-gradient(90deg, rgba(15, 23, 42, 0.04) 1px, transparent 1px);
  background-size: 48px 48px;
  pointer-events: none;
  mask-image: radial-gradient(ellipse at center, black 30%, transparent 75%);
}

._shared_heroInner__yhSjb {
  position: relative;
  max-width: 1100px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: minmax(0, 1.5fr) auto;
  gap: var(--sp-10);
  align-items: center;
}
@media (max-width: 900px) {
  ._shared_heroInner__yhSjb {
    grid-template-columns: 1fr;
  }
}

._shared_eyebrow__EkFBV {
  display: inline-flex;
  align-items: center;
  gap: var(--sp-2);
  font-size: 13px;
  font-weight: var(--fw-semibold);
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: var(--color-primary-hover);
  margin-bottom: var(--sp-4);
}
._shared_eyebrow__EkFBV::before {
  content: "";
  width: 28px;
  height: 2px;
  background: linear-gradient(90deg, #0EA5E9, transparent);
  border-radius: var(--radius-pill);
}

._shared_heroTitle__ALqY2 {
  font-size: 56px;
  font-weight: var(--fw-bold);
  line-height: 1.05;
  letter-spacing: -0.02em;
  margin: 0 0 var(--sp-5);
  color: var(--color-text);
}
@media (max-width: 600px) {
  ._shared_heroTitle__ALqY2 {
    font-size: 40px;
  }
}

._shared_brandGradient__51lej {
  background: linear-gradient(135deg, #0EA5E9 0%, #8B5CF6 50%, #EC4899 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
}

._shared_heroSubtitle__wDkQR {
  font-size: 18px;
  line-height: 1.6;
  color: var(--color-text-muted);
  max-width: 640px;
  margin: 0 0 var(--sp-6);
}

._shared_heroActions__m5r\\+K {
  display: flex;
  gap: var(--sp-3);
  flex-wrap: wrap;
}

._shared_heroBadge__ahGJr {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 168px;
  height: 168px;
  border-radius: var(--radius-2xl);
  background: linear-gradient(135deg, rgba(14, 165, 233, 0.12) 0%, rgba(139, 92, 246, 0.12) 100%);
  border: 1px solid var(--color-border);
  box-shadow: 0 0 0 1px rgba(14, 165, 233, 0.12) inset, 0 24px 60px -20px rgba(14, 165, 233, 0.3);
}
._shared_heroBadge__ahGJr svg {
  font-size: 88px !important;
  width: 88px !important;
  height: 88px !important;
  color: var(--color-primary);
  filter: drop-shadow(0 0 18px rgba(14, 165, 233, 0.35));
}
@media (max-width: 900px) {
  ._shared_heroBadge__ahGJr {
    margin-top: var(--sp-4);
  }
}

._shared_btnPrimary__P6Rqg,
._shared_btnSecondary__QEe1b {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--sp-2);
  height: 44px;
  padding: 0 var(--sp-6);
  font-size: 16px;
  font-weight: var(--fw-semibold);
  border-radius: var(--radius-md);
  border: 1px solid transparent;
  cursor: pointer;
  transition: transform var(--duration-base) var(--easing-standard), box-shadow var(--duration-base) var(--easing-standard), background var(--duration-base) var(--easing-standard);
  font-family: var(--font-sans);
}

._shared_btnPrimary__P6Rqg {
  background: linear-gradient(135deg, #0EA5E9 0%, #8B5CF6 100%);
  color: #ffffff;
  box-shadow: 0 8px 20px -6px rgba(14, 165, 233, 0.6);
}
._shared_btnPrimary__P6Rqg:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 28px -8px rgba(14, 165, 233, 0.7);
}

._shared_btnSecondary__QEe1b {
  background: var(--color-bg);
  color: var(--color-text);
  border-color: var(--color-border-strong);
}
._shared_btnSecondary__QEe1b:hover {
  background: var(--color-bg-subtle);
  border-color: var(--color-primary);
  color: var(--color-primary-hover);
}

._shared_section__ZBpRn {
  max-width: 1100px;
  margin: var(--sp-16) auto 0;
  padding: 0 var(--sp-10);
}
@media (max-width: 600px) {
  ._shared_section__ZBpRn {
    padding: 0 var(--sp-5);
  }
}

._shared_sectionHeader__xYkce {
  text-align: center;
  margin-bottom: var(--sp-10);
}

._shared_sectionEyebrow__eo-NX {
  display: inline-block;
  font-size: 13px;
  font-weight: var(--fw-semibold);
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: var(--color-primary);
  margin-bottom: var(--sp-3);
}

._shared_sectionTitle__ocOTW {
  font-size: 36px;
  font-weight: var(--fw-bold);
  letter-spacing: -0.02em;
  color: var(--color-text);
  margin: 0 0 var(--sp-3);
}
@media (max-width: 600px) {
  ._shared_sectionTitle__ocOTW {
    font-size: 28px;
  }
}

._shared_sectionLead__Ag4ay {
  font-size: 17px;
  line-height: 1.6;
  color: var(--color-text-muted);
  max-width: 720px;
  margin: 0 auto;
}

._shared_featureGrid__l0uYB {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--sp-6);
}
@media (max-width: 900px) {
  ._shared_featureGrid__l0uYB {
    grid-template-columns: 1fr;
  }
}

._shared_featureCard__8oM4A {
  position: relative;
  background-color: var(--color-bg);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-xl);
  padding: var(--sp-8);
  box-shadow: var(--shadow-sm);
  overflow: hidden;
  transition: transform var(--duration-base) var(--easing-standard), box-shadow var(--duration-base) var(--easing-standard), border-color var(--duration-base) var(--easing-standard);
}
._shared_featureCard__8oM4A::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #0EA5E9, #8B5CF6);
  opacity: 0.85;
}
._shared_featureCard__8oM4A:hover {
  transform: translateY(-4px);
  box-shadow: var(--shadow-lg);
  border-color: rgba(14, 165, 233, 0.3);
}

._shared_featureIcon__YvGnb {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  border-radius: var(--radius-lg);
  background: linear-gradient(135deg, rgba(14, 165, 233, 0.12) 0%, rgba(139, 92, 246, 0.12) 100%);
  margin-bottom: var(--sp-5);
}
._shared_featureIcon__YvGnb svg {
  font-size: 32px !important;
  width: 32px !important;
  height: 32px !important;
  color: var(--color-primary);
}

._shared_featureTag__PhJLG {
  display: inline-block;
  font-size: 12px;
  font-weight: var(--fw-bold);
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--color-primary);
  padding: 4px 10px;
  border-radius: var(--radius-pill);
  background-color: var(--color-primary-soft);
  margin-bottom: var(--sp-3);
}

._shared_featureTitle__bMMgN {
  font-size: 24px;
  font-weight: var(--fw-bold);
  color: var(--color-text);
  margin: 0 0 var(--sp-3);
  letter-spacing: -0.01em;
}

._shared_featureDesc__1S2Q9 {
  font-size: 16px;
  line-height: 1.6;
  color: var(--color-text-muted);
  margin: 0 0 var(--sp-5);
}

._shared_featureBullets__vV-UV {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: var(--sp-2);
}
._shared_featureBullets__vV-UV li {
  display: flex;
  align-items: center;
  gap: var(--sp-2);
  font-size: 15px;
  color: var(--color-text);
}
._shared_featureBullets__vV-UV li::before {
  content: "";
  width: 6px;
  height: 6px;
  border-radius: var(--radius-pill);
  background: linear-gradient(135deg, #0EA5E9, #8B5CF6);
  flex-shrink: 0;
}

._shared_benefitGrid__5914P {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: var(--sp-4);
}
@media (max-width: 900px) {
  ._shared_benefitGrid__5914P {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 500px) {
  ._shared_benefitGrid__5914P {
    grid-template-columns: 1fr;
  }
}

._shared_benefitCard__gTDNH {
  background-color: var(--color-bg);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  padding: var(--sp-6);
  text-align: left;
  transition: transform var(--duration-base) var(--easing-standard), box-shadow var(--duration-base) var(--easing-standard);
}
._shared_benefitCard__gTDNH:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

._shared_benefitIcon__qXZO7 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: var(--radius-md);
  background: linear-gradient(135deg, rgba(14, 165, 233, 0.1) 0%, rgba(139, 92, 246, 0.1) 100%);
  margin-bottom: var(--sp-3);
}
._shared_benefitIcon__qXZO7 svg {
  font-size: 22px !important;
  width: 22px !important;
  height: 22px !important;
  color: var(--color-primary);
}

._shared_benefitTitle__pqn48 {
  font-size: 17px;
  font-weight: var(--fw-bold);
  color: var(--color-text);
  margin: 0 0 var(--sp-2);
}

._shared_benefitDesc__QDqE5 {
  font-size: 14px;
  line-height: 1.55;
  color: var(--color-text-muted);
  margin: 0;
}

._shared_chipGroup__AupSw {
  display: flex;
  flex-wrap: wrap;
  gap: var(--sp-2);
  margin: var(--sp-4) 0 var(--sp-6);
}

._shared_chip__0yQuG {
  display: inline-flex;
  align-items: center;
  gap: var(--sp-2);
  height: 32px;
  padding: 0 var(--sp-3);
  background-color: var(--color-bg-muted);
  color: var(--color-text-muted);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-pill);
  font-size: 14px;
  font-weight: var(--fw-medium);
}
._shared_chip__0yQuG strong {
  color: var(--color-text);
  font-weight: var(--fw-semibold);
}

._shared_chipBrand__YQjgx {
  background-color: var(--color-primary-soft);
  color: var(--color-primary-hover);
  border-color: rgba(14, 165, 233, 0.3);
}

._shared_stepList__ZyfXg {
  display: flex;
  flex-direction: column;
  gap: var(--sp-5);
}

._shared_step__mdJA5 {
  display: grid;
  grid-template-columns: 64px 1fr;
  gap: var(--sp-5);
  background-color: var(--color-bg);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-xl);
  padding: var(--sp-6);
  box-shadow: var(--shadow-xs);
  transition: box-shadow var(--duration-base) var(--easing-standard);
}
._shared_step__mdJA5:hover {
  box-shadow: var(--shadow-sm);
}
@media (max-width: 600px) {
  ._shared_step__mdJA5 {
    grid-template-columns: 48px 1fr;
    gap: var(--sp-4);
    padding: var(--sp-5);
  }
}

._shared_stepNumber__0Bn1M {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: var(--radius-lg);
  background: linear-gradient(135deg, #0EA5E9 0%, #8B5CF6 100%);
  color: #ffffff;
  font-size: 22px;
  font-weight: var(--fw-bold);
  box-shadow: 0 8px 20px -6px rgba(14, 165, 233, 0.5);
}
@media (max-width: 600px) {
  ._shared_stepNumber__0Bn1M {
    width: 44px;
    height: 44px;
    font-size: 18px;
  }
}

._shared_stepBody__iLbFM {
  min-width: 0;
}

._shared_stepTitle__e-NdJ {
  font-size: 20px;
  font-weight: var(--fw-bold);
  color: var(--color-text);
  margin: 0 0 var(--sp-2);
  letter-spacing: -0.01em;
}

._shared_stepDesc__Rc3aF {
  font-size: 16px;
  line-height: 1.65;
  color: var(--color-text-muted);
  margin: 0 0 var(--sp-4);
}
._shared_stepDesc__Rc3aF:last-child {
  margin-bottom: 0;
}

._shared_commandBlock__QQn4W {
  background: linear-gradient(180deg, #0F172A 0%, #0B1120 100%);
  border: 1px solid #1E293B;
  border-radius: var(--radius-lg);
  padding: var(--sp-4) var(--sp-5);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--sp-4);
  margin: var(--sp-3) 0;
  position: relative;
  transition: border-color var(--duration-base) var(--easing-standard);
}
._shared_commandBlock__QQn4W:hover {
  border-color: rgba(56, 189, 248, 0.5);
}
._shared_commandBlock__QQn4W code {
  flex: 1 1;
  color: #E2E8F0;
  font-family: var(--font-mono);
  font-size: 15px;
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-all;
  background: none;
  padding: 0;
}
._shared_commandBlock__QQn4W::before {
  content: "\$";
  color: #38BDF8;
  font-family: var(--font-mono);
  font-size: 15px;
  font-weight: var(--fw-bold);
  margin-right: var(--sp-1);
}

._shared_commandBlockLarge__wUfS- {
  align-items: stretch;
  padding: var(--sp-5);
}
._shared_commandBlockLarge__wUfS-::before {
  display: none;
}
._shared_commandBlockLarge__wUfS- code {
  display: block;
  white-space: pre;
  overflow-x: auto;
  font-size: 14px;
}

._shared_copyButton__U5dS5 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.06);
  color: #94A3B8;
  border-radius: var(--radius-md);
  cursor: pointer;
  flex-shrink: 0;
  transition: background var(--duration-base) var(--easing-standard), color var(--duration-base) var(--easing-standard), border-color var(--duration-base) var(--easing-standard);
  position: relative;
}
._shared_copyButton__U5dS5:hover {
  background: rgba(56, 189, 248, 0.15);
  border-color: rgba(56, 189, 248, 0.5);
  color: #38BDF8;
}
._shared_copyButton__U5dS5 svg {
  width: 18px;
  height: 18px;
  fill: none;
  stroke: currentColor;
  stroke-width: 32px;
}
._shared_copyButton__U5dS5._shared_copied__b-Qrv {
  background: rgba(16, 185, 129, 0.18);
  border-color: rgba(16, 185, 129, 0.5);
  color: #10B981;
}
._shared_copyButton__U5dS5._shared_copied__b-Qrv::after {
  content: "Copied";
  position: absolute;
  bottom: calc(100% + 6px);
  right: 0;
  padding: 4px 10px;
  background: #0F172A;
  color: #E2E8F0;
  font-size: 12px;
  font-family: var(--font-sans);
  border-radius: var(--radius-md);
  white-space: nowrap;
  box-shadow: var(--shadow-md);
}

._shared_callout__Pke7- {
  padding: var(--sp-5);
  border-radius: var(--radius-lg);
  border: 1px solid var(--color-border);
  background-color: var(--color-bg);
  margin: var(--sp-4) 0;
  font-size: 16px;
  line-height: 1.65;
  color: var(--color-text-muted);
}
._shared_callout__Pke7- strong {
  color: var(--color-text);
}
[data-theme=dark] ._shared_callout__Pke7- strong {
  color: #7DD3FC;
}

._shared_calloutBrand__MZkwH {
  background: linear-gradient(135deg, var(--color-primary-soft) 0%, #F5F3FF 100%);
  border-color: rgba(14, 165, 233, 0.35);
  color: var(--color-text);
}
[data-theme=dark] ._shared_calloutBrand__MZkwH {
  background: linear-gradient(135deg, rgba(56, 189, 248, 0.18) 0%, rgba(139, 92, 246, 0.18) 100%);
  border-color: rgba(56, 189, 248, 0.35);
}

._shared_pillGrid__vdEp0 {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: var(--sp-3);
  margin-top: var(--sp-4);
}

._shared_pillCard__b6GRt {
  display: flex;
  align-items: center;
  gap: var(--sp-3);
  padding: var(--sp-4);
  background-color: var(--color-bg);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  transition: border-color var(--duration-base) var(--easing-standard), box-shadow var(--duration-base) var(--easing-standard);
}
._shared_pillCard__b6GRt:hover {
  border-color: rgba(14, 165, 233, 0.35);
  box-shadow: var(--shadow-sm);
}
._shared_pillCard__b6GRt svg {
  color: var(--color-primary);
  font-size: 22px !important;
  width: 22px !important;
  height: 22px !important;
  flex-shrink: 0;
}

._shared_pillLabel__NK1ZY {
  font-size: 15px;
  font-weight: var(--fw-medium);
  color: var(--color-text);
}

._shared_closing__0N4k9 {
  margin-top: var(--sp-16);
  padding: 0 var(--sp-10);
}
@media (max-width: 600px) {
  ._shared_closing__0N4k9 {
    padding: 0 var(--sp-5);
  }
}

._shared_closingBox__-zdE7 {
  max-width: 1100px;
  margin: 0 auto;
  padding: var(--sp-12) var(--sp-10);
  background: radial-gradient(ellipse at 30% 40%, rgba(14, 165, 233, 0.08) 0%, transparent 60%), radial-gradient(ellipse at 70% 60%, rgba(139, 92, 246, 0.08) 0%, transparent 60%), linear-gradient(135deg, #FFFFFF 0%, var(--color-bg-subtle) 100%);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-2xl);
  text-align: center;
  color: var(--color-text);
  box-shadow: var(--shadow-sm);
}
._shared_closingBox__-zdE7 h2 {
  font-size: 32px;
  font-weight: var(--fw-bold);
  margin: 0 0 var(--sp-3);
  letter-spacing: -0.01em;
  color: var(--color-text);
}
._shared_closingBox__-zdE7 p {
  font-size: 16px;
  line-height: 1.65;
  color: var(--color-text-muted);
  margin: 0 auto var(--sp-6);
  max-width: 560px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Guide/_shared.module.scss"],"names":[],"mappings":"AAMA;EACE,WAAA;EACA,gBAAA;EACA,wCAAA;EACA,4BAAA;AALF;;AASA;EACE,kBAAA;EACA,gBAAA;EACA,kCAAA;EAIA,wPACE;EAGF,wBAAA;AAZF;;AAkBA;EACE,kBAAA;EACA,QAAA;EACA,mJACE;EAEF,0BAAA;EACA,oBAAA;EACA,0EAAA;AAjBF;;AAoBA;EACE,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;EACA,4CAAA;EACA,iBAAA;EACA,mBAAA;AAjBF;AAmBE;EATF;IAUI,0BAAA;EAhBF;AACF;;AAmBA;EACE,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,+BAAA;EACA,sBAAA;EACA,yBAAA;EAEA,iCAAA;EACA,0BAAA;AAjBF;AAmBE;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,wDAAA;EACA,iCAAA;AAjBJ;;AAqBA;EACE,eAAA;EACA,2BAAA;EACA,iBAAA;EACA,uBAAA;EACA,uBAAA;EAEA,wBAAA;AAnBF;AAqBE;EATF;IAUI,eAAA;EAlBF;AACF;;AAqBA;EAIE,0EAAA;EACA,6BAAA;EACA,qBAAA;EACA,oCAAA;EACA,kBAAA;AArBF;;AAwBA;EACE,eAAA;EACA,gBAAA;EAEA,8BAAA;EACA,gBAAA;EACA,uBAAA;AAtBF;;AAyBA;EACE,aAAA;EACA,gBAAA;EACA,eAAA;AAtBF;;AAyBA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,gCAAA;EAGA,+FACE;EACF,qCAAA;EACA,+FACE;AA1BJ;AA6BE;EACE,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;EACA,sDAAA;AA3BJ;AA8BE;EAxBF;IAyBI,uBAAA;EA3BF;AACF;;AA+BA;;EAEE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;EACA,+BAAA;EACA,+BAAA;EACA,6BAAA;EACA,eAAA;EACA,iLAAA;EAGA,6BAAA;AA9BF;;AAiCA;EACE,6DAAA;EACA,cAAA;EACA,mDAAA;AA9BF;AAgCE;EACE,2BAAA;EACA,oDAAA;AA9BJ;;AAkCA;EAEE,2BAAA;EACA,wBAAA;EACA,wCAAA;AAhCF;AAkCE;EACE,kCAAA;EACA,kCAAA;EACA,iCAAA;AAhCJ;;AAqCA;EACE,iBAAA;EACA,2BAAA;EACA,uBAAA;AAlCF;AAoCE;EALF;IAMI,sBAAA;EAjCF;AACF;;AAoCA;EACE,kBAAA;EACA,2BAAA;AAjCF;;AAoCA;EACE,qBAAA;EACA,eAAA;EACA,+BAAA;EACA,sBAAA;EACA,yBAAA;EACA,2BAAA;EACA,0BAAA;AAjCF;;AAoCA;EACE,eAAA;EACA,2BAAA;EACA,uBAAA;EACA,wBAAA;EACA,uBAAA;AAjCF;AAmCE;EAPF;IAQI,eAAA;EAhCF;AACF;;AAmCA;EACE,eAAA;EACA,gBAAA;EACA,8BAAA;EACA,gBAAA;EACA,cAAA;AAhCF;;AAoCA;EACE,aAAA;EACA,gDAAA;EACA,gBAAA;AAjCF;AAmCE;EALF;IAMI,0BAAA;EAhCF;AACF;;AAmCA;EACE,kBAAA;EACA,iCAAA;EACA,qCAAA;EACA,+BAAA;EACA,oBAAA;EACA,4BAAA;EACA,gBAAA;EACA,mLAAA;AAhCF;AAoCE;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,WAAA;EACA,oDAAA;EACA,aAAA;AAlCJ;AAqCE;EACE,2BAAA;EACA,4BAAA;EACA,qCAAA;AAnCJ;;AAuCA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,+BAAA;EACA,+FAAA;EACA,0BAAA;AApCF;AAsCE;EACE,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;AApCJ;;AAwCA;EACE,qBAAA;EACA,eAAA;EACA,2BAAA;EACA,sBAAA;EACA,yBAAA;EACA,2BAAA;EACA,iBAAA;EACA,iCAAA;EACA,2CAAA;EACA,0BAAA;AArCF;;AAwCA;EACE,eAAA;EACA,2BAAA;EACA,wBAAA;EACA,uBAAA;EACA,uBAAA;AArCF;;AAwCA;EACE,eAAA;EACA,gBAAA;EACA,8BAAA;EACA,uBAAA;AArCF;;AAwCA;EACE,gBAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AArCF;AAuCE;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,wBAAA;AArCJ;AAuCI;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,iCAAA;EACA,qDAAA;EACA,cAAA;AArCN;;AA2CA;EACE,aAAA;EACA,gDAAA;EACA,gBAAA;AAxCF;AA0CE;EALF;IAMI,gDAAA;EAvCF;AACF;AAwCE;EARF;IASI,0BAAA;EArCF;AACF;;AAwCA;EACE,iCAAA;EACA,qCAAA;EACA,+BAAA;EACA,oBAAA;EACA,gBAAA;EACA,yHAAA;AArCF;AAwCE;EACE,2BAAA;EACA,4BAAA;AAtCJ;;AA0CA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,+BAAA;EACA,6FAAA;EACA,0BAAA;AAvCF;AAyCE;EACE,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;AAvCJ;;AA2CA;EACE,eAAA;EACA,2BAAA;EACA,wBAAA;EACA,uBAAA;AAxCF;;AA2CA;EACE,eAAA;EACA,iBAAA;EACA,8BAAA;EACA,SAAA;AAxCF;;AA4CA;EACE,aAAA;EACA,eAAA;EACA,gBAAA;EACA,iCAAA;AAzCF;;AA4CA;EACE,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,sBAAA;EACA,uCAAA;EACA,8BAAA;EACA,qCAAA;EACA,iCAAA;EACA,eAAA;EACA,6BAAA;AAzCF;AA2CE;EACE,wBAAA;EACA,+BAAA;AAzCJ;;AA6CA;EACE,2CAAA;EACA,iCAAA;EACA,qCAAA;AA1CF;;AA8CA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AA3CF;;AA8CA;EACE,aAAA;EACA,+BAAA;EACA,gBAAA;EACA,iCAAA;EACA,qCAAA;EACA,+BAAA;EACA,oBAAA;EACA,4BAAA;EACA,kEAAA;AA3CF;AA6CE;EAAU,4BAAA;AA1CZ;AA4CE;EAbF;IAcI,+BAAA;IACA,gBAAA;IACA,oBAAA;EAzCF;AACF;;AA4CA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,+BAAA;EACA,6DAAA;EACA,cAAA;EACA,eAAA;EACA,2BAAA;EACA,mDAAA;AAzCF;AA2CE;EAbF;IAcI,WAAA;IACA,YAAA;IACA,eAAA;EAxCF;AACF;;AA2CA;EACE,YAAA;AAxCF;;AA2CA;EACE,eAAA;EACA,2BAAA;EACA,wBAAA;EACA,uBAAA;EACA,uBAAA;AAxCF;;AA2CA;EACE,eAAA;EACA,iBAAA;EACA,8BAAA;EACA,uBAAA;AAxCF;AA0CE;EAAe,gBAAA;AAvCjB;;AA2CA;EACE,6DACE;EACF,yBAAA;EACA,+BAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,oEAAA;AAzCF;AA2CE;EACE,qCAAA;AAzCJ;AA4CE;EACE,SAAA;EACA,cAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,qBAAA;EACA,gBAAA;EACA,UAAA;AA1CJ;AA6CE;EACE,YAAA;EACA,cAAA;EACA,6BAAA;EACA,eAAA;EACA,2BAAA;EACA,yBAAA;AA3CJ;;AA+CA;EACE,oBAAA;EACA,oBAAA;AA5CF;AA8CE;EAAY,aAAA;AA3Cd;AA6CE;EACE,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AA3CJ;;AA+CA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,0CAAA;EACA,qCAAA;EACA,cAAA;EACA,+BAAA;EACA,eAAA;EACA,cAAA;EACA,+KAAA;EAGA,kBAAA;AA9CF;AAgDE;EACE,oCAAA;EACA,qCAAA;EACA,cAAA;AA9CJ;AAiDE;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,oBAAA;EACA,kBAAA;AA/CJ;AAkDE;EACE,oCAAA;EACA,qCAAA;EACA,cAAA;AAhDJ;AAkDI;EACE,iBAAA;EACA,kBAAA;EACA,wBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,6BAAA;EACA,+BAAA;EACA,mBAAA;EACA,4BAAA;AAhDN;;AAsDA;EACE,oBAAA;EACA,+BAAA;EACA,qCAAA;EACA,iCAAA;EACA,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,8BAAA;AAnDF;AAqDE;EAAS,wBAAA;AAlDX;AAsDE;EACE,cAAA;AApDJ;;AAwDA;EACE,+EAAA;EACA,sCAAA;EACA,wBAAA;AArDF;AAyDE;EACE,+FAAA;EACA,sCAAA;AAvDJ;;AA4DA;EACE,aAAA;EACA,4DAAA;EACA,gBAAA;EACA,uBAAA;AAzDF;;AA4DA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,iCAAA;EACA,qCAAA;EACA,+BAAA;EACA,4HAAA;AAzDF;AA4DE;EACE,sCAAA;EACA,4BAAA;AA1DJ;AA6DE;EACE,2BAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,cAAA;AA3DJ;;AA+DA;EACE,eAAA;EACA,6BAAA;EACA,wBAAA;AA5DF;;AAgEA;EACE,wBAAA;EACA,uBAAA;AA7DF;AA+DE;EAJF;IAKI,sBAAA;EA5DF;AACF;;AA+DA;EAIE,iBAAA;EACA,cAAA;EACA,kCAAA;EACA,kPACE;EAGF,qCAAA;EACA,gCAAA;EACA,kBAAA;EACA,wBAAA;EACA,4BAAA;AAlEF;AAoEE;EACE,eAAA;EACA,2BAAA;EACA,uBAAA;EACA,uBAAA;EACA,wBAAA;AAlEJ;AAqEE;EACE,eAAA;EACA,iBAAA;EACA,8BAAA;EACA,0BAAA;EACA,gBAAA;AAnEJ","sourcesContent":["// Shared design primitives for guide / introduction pages (/home, /sosguide,\n// /sarguide, /workbook). Body font sizes preserved per user feedback.\n\n@use '../../styles/tokens' as *;\n\n// ---------- Page shell ----------\n.page {\n  width: 100%;\n  min-height: 100%;\n  background-color: var(--color-bg-subtle);\n  padding-bottom: var(--sp-16);\n}\n\n// ---------- Hero (light tone — unified with the white app shell) ----------\n.hero {\n  position: relative;\n  overflow: hidden;\n  padding: var(--sp-16) var(--sp-10);\n  // 시작색을 navbar/page와 동일한 var(--color-bg)로 토큰화. 라이트=흰색→slate-50로\n  // 거의 차이 없음, 다크=slate-900→slate-800로 살짝 깊어짐. 양쪽 모드 다 navbar와\n  // 자연스럽게 연결되도록.\n  background:\n    radial-gradient(ellipse at 20% 30%, rgba(14, 165, 233, 0.10) 0%, transparent 55%),\n    radial-gradient(ellipse at 80% 70%, rgba(139, 92, 246, 0.10) 0%, transparent 55%),\n    linear-gradient(135deg, var(--color-bg) 0%, var(--color-bg-subtle) 100%);\n  color: var(--color-text);\n  // border-radius / border-bottom / box-shadow 모두 제거 — \"카드처럼 떠있는\"\n  // 둥근 모서리와 하단 라인이 navbar와의 구분선을 강하게 만들고 있었음.\n}\n\n// Decorative grid overlay on the hero — dark hairlines on the light background.\n.heroGridOverlay {\n  position: absolute;\n  inset: 0;\n  background-image:\n    linear-gradient(rgba(15, 23, 42, 0.04) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(15, 23, 42, 0.04) 1px, transparent 1px);\n  background-size: 48px 48px;\n  pointer-events: none;\n  mask-image: radial-gradient(ellipse at center, black 30%, transparent 75%);\n}\n\n.heroInner {\n  position: relative;\n  max-width: 1100px;\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: minmax(0, 1.5fr) auto;\n  gap: var(--sp-10);\n  align-items: center;\n\n  @media (max-width: 900px) {\n    grid-template-columns: 1fr;\n  }\n}\n\n.eyebrow {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--sp-2);\n  font-size: 13px;\n  font-weight: var(--fw-semibold);\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  // sky-600 reads well on the light hero (was sky-300 / #7DD3FC for the dark slab)\n  color: var(--color-primary-hover);\n  margin-bottom: var(--sp-4);\n\n  &::before {\n    content: '';\n    width: 28px;\n    height: 2px;\n    background: linear-gradient(90deg, #0EA5E9, transparent);\n    border-radius: var(--radius-pill);\n  }\n}\n\n.heroTitle {\n  font-size: 56px;\n  font-weight: var(--fw-bold);\n  line-height: 1.05;\n  letter-spacing: -0.02em;\n  margin: 0 0 var(--sp-5);\n  // Darkened from #ffffff to slate-900 so the title reads on the white hero.\n  color: var(--color-text);\n\n  @media (max-width: 600px) {\n    font-size: 40px;\n  }\n}\n\n.brandGradient {\n  // Saturated brand gradient (sky-500 → violet-500 → pink-500). The previous\n  // pastel variant (#38BDF8 → #A78BFA → #F472B6) was tuned for the dark slab\n  // and washed out against white.\n  background: linear-gradient(135deg, #0EA5E9 0%, #8B5CF6 50%, #EC4899 100%);\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n  color: transparent;\n}\n\n.heroSubtitle {\n  font-size: 18px;\n  line-height: 1.6;\n  // slate-600 — readable body copy on white (was slate-100 alpha for the dark slab)\n  color: var(--color-text-muted);\n  max-width: 640px;\n  margin: 0 0 var(--sp-6);\n}\n\n.heroActions {\n  display: flex;\n  gap: var(--sp-3);\n  flex-wrap: wrap;\n}\n\n.heroBadge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 168px;\n  height: 168px;\n  border-radius: var(--radius-2xl);\n  // Lightened tint + soft tokenized border for the white hero. Icon now uses\n  // brand-primary instead of pure white so it stays visible without the dark slab.\n  background:\n    linear-gradient(135deg, rgba(14, 165, 233, 0.12) 0%, rgba(139, 92, 246, 0.12) 100%);\n  border: 1px solid var(--color-border);\n  box-shadow:\n    0 0 0 1px rgba(14, 165, 233, 0.12) inset,\n    0 24px 60px -20px rgba(14, 165, 233, 0.30);\n\n  svg {\n    font-size: 88px !important;\n    width: 88px !important;\n    height: 88px !important;\n    color: var(--color-primary);\n    filter: drop-shadow(0 0 18px rgba(14, 165, 233, 0.35));\n  }\n\n  @media (max-width: 900px) {\n    margin-top: var(--sp-4);\n  }\n}\n\n// ---------- Buttons ----------\n.btnPrimary,\n.btnSecondary {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--sp-2);\n  height: 44px;\n  padding: 0 var(--sp-6);\n  font-size: 16px;\n  font-weight: var(--fw-semibold);\n  border-radius: var(--radius-md);\n  border: 1px solid transparent;\n  cursor: pointer;\n  transition: transform var(--duration-base) var(--easing-standard),\n              box-shadow var(--duration-base) var(--easing-standard),\n              background var(--duration-base) var(--easing-standard);\n  font-family: var(--font-sans);\n}\n\n.btnPrimary {\n  background: linear-gradient(135deg, #0EA5E9 0%, #8B5CF6 100%);\n  color: #ffffff;\n  box-shadow: 0 8px 20px -6px rgba(14, 165, 233, 0.6);\n\n  &:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 12px 28px -8px rgba(14, 165, 233, 0.7);\n  }\n}\n\n.btnSecondary {\n  // Tokenized outline button for the light hero (was white-on-translucent for dark).\n  background: var(--color-bg);\n  color: var(--color-text);\n  border-color: var(--color-border-strong);\n\n  &:hover {\n    background: var(--color-bg-subtle);\n    border-color: var(--color-primary);\n    color: var(--color-primary-hover);\n  }\n}\n\n// ---------- Section header ----------\n.section {\n  max-width: 1100px;\n  margin: var(--sp-16) auto 0;\n  padding: 0 var(--sp-10);\n\n  @media (max-width: 600px) {\n    padding: 0 var(--sp-5);\n  }\n}\n\n.sectionHeader {\n  text-align: center;\n  margin-bottom: var(--sp-10);\n}\n\n.sectionEyebrow {\n  display: inline-block;\n  font-size: 13px;\n  font-weight: var(--fw-semibold);\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  color: var(--color-primary);\n  margin-bottom: var(--sp-3);\n}\n\n.sectionTitle {\n  font-size: 36px;\n  font-weight: var(--fw-bold);\n  letter-spacing: -0.02em;\n  color: var(--color-text);\n  margin: 0 0 var(--sp-3);\n\n  @media (max-width: 600px) {\n    font-size: 28px;\n  }\n}\n\n.sectionLead {\n  font-size: 17px;\n  line-height: 1.6;\n  color: var(--color-text-muted);\n  max-width: 720px;\n  margin: 0 auto;\n}\n\n// ---------- Feature card (large, two-up) ----------\n.featureGrid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: var(--sp-6);\n\n  @media (max-width: 900px) {\n    grid-template-columns: 1fr;\n  }\n}\n\n.featureCard {\n  position: relative;\n  background-color: var(--color-bg);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-xl);\n  padding: var(--sp-8);\n  box-shadow: var(--shadow-sm);\n  overflow: hidden;\n  transition: transform var(--duration-base) var(--easing-standard),\n              box-shadow var(--duration-base) var(--easing-standard),\n              border-color var(--duration-base) var(--easing-standard);\n\n  &::before {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 0;\n    right: 0;\n    height: 4px;\n    background: linear-gradient(90deg, #0EA5E9, #8B5CF6);\n    opacity: 0.85;\n  }\n\n  &:hover {\n    transform: translateY(-4px);\n    box-shadow: var(--shadow-lg);\n    border-color: rgba(14, 165, 233, 0.3);\n  }\n}\n\n.featureIcon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 60px;\n  height: 60px;\n  border-radius: var(--radius-lg);\n  background: linear-gradient(135deg, rgba(14, 165, 233, 0.12) 0%, rgba(139, 92, 246, 0.12) 100%);\n  margin-bottom: var(--sp-5);\n\n  svg {\n    font-size: 32px !important;\n    width: 32px !important;\n    height: 32px !important;\n    color: var(--color-primary);\n  }\n}\n\n.featureTag {\n  display: inline-block;\n  font-size: 12px;\n  font-weight: var(--fw-bold);\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: var(--color-primary);\n  padding: 4px 10px;\n  border-radius: var(--radius-pill);\n  background-color: var(--color-primary-soft);\n  margin-bottom: var(--sp-3);\n}\n\n.featureTitle {\n  font-size: 24px;\n  font-weight: var(--fw-bold);\n  color: var(--color-text);\n  margin: 0 0 var(--sp-3);\n  letter-spacing: -0.01em;\n}\n\n.featureDesc {\n  font-size: 16px;\n  line-height: 1.6;\n  color: var(--color-text-muted);\n  margin: 0 0 var(--sp-5);\n}\n\n.featureBullets {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: var(--sp-2);\n\n  li {\n    display: flex;\n    align-items: center;\n    gap: var(--sp-2);\n    font-size: 15px;\n    color: var(--color-text);\n\n    &::before {\n      content: '';\n      width: 6px;\n      height: 6px;\n      border-radius: var(--radius-pill);\n      background: linear-gradient(135deg, #0EA5E9, #8B5CF6);\n      flex-shrink: 0;\n    }\n  }\n}\n\n// ---------- Benefit/Stats grid (smaller cards) ----------\n.benefitGrid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: var(--sp-4);\n\n  @media (max-width: 900px) {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n  @media (max-width: 500px) {\n    grid-template-columns: 1fr;\n  }\n}\n\n.benefitCard {\n  background-color: var(--color-bg);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-lg);\n  padding: var(--sp-6);\n  text-align: left;\n  transition: transform var(--duration-base) var(--easing-standard),\n              box-shadow var(--duration-base) var(--easing-standard);\n\n  &:hover {\n    transform: translateY(-2px);\n    box-shadow: var(--shadow-md);\n  }\n}\n\n.benefitIcon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  border-radius: var(--radius-md);\n  background: linear-gradient(135deg, rgba(14, 165, 233, 0.1) 0%, rgba(139, 92, 246, 0.1) 100%);\n  margin-bottom: var(--sp-3);\n\n  svg {\n    font-size: 22px !important;\n    width: 22px !important;\n    height: 22px !important;\n    color: var(--color-primary);\n  }\n}\n\n.benefitTitle {\n  font-size: 17px;\n  font-weight: var(--fw-bold);\n  color: var(--color-text);\n  margin: 0 0 var(--sp-2);\n}\n\n.benefitDesc {\n  font-size: 14px;\n  line-height: 1.55;\n  color: var(--color-text-muted);\n  margin: 0;\n}\n\n// ---------- Chip / Tag group ----------\n.chipGroup {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--sp-2);\n  margin: var(--sp-4) 0 var(--sp-6);\n}\n\n.chip {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--sp-2);\n  height: 32px;\n  padding: 0 var(--sp-3);\n  background-color: var(--color-bg-muted);\n  color: var(--color-text-muted);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-pill);\n  font-size: 14px;\n  font-weight: var(--fw-medium);\n\n  strong {\n    color: var(--color-text);\n    font-weight: var(--fw-semibold);\n  }\n}\n\n.chipBrand {\n  background-color: var(--color-primary-soft);\n  color: var(--color-primary-hover);\n  border-color: rgba(14, 165, 233, 0.3);\n}\n\n// ---------- Step (numbered guide step) ----------\n.stepList {\n  display: flex;\n  flex-direction: column;\n  gap: var(--sp-5);\n}\n\n.step {\n  display: grid;\n  grid-template-columns: 64px 1fr;\n  gap: var(--sp-5);\n  background-color: var(--color-bg);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-xl);\n  padding: var(--sp-6);\n  box-shadow: var(--shadow-xs);\n  transition: box-shadow var(--duration-base) var(--easing-standard);\n\n  &:hover { box-shadow: var(--shadow-sm); }\n\n  @media (max-width: 600px) {\n    grid-template-columns: 48px 1fr;\n    gap: var(--sp-4);\n    padding: var(--sp-5);\n  }\n}\n\n.stepNumber {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 56px;\n  height: 56px;\n  border-radius: var(--radius-lg);\n  background: linear-gradient(135deg, #0EA5E9 0%, #8B5CF6 100%);\n  color: #ffffff;\n  font-size: 22px;\n  font-weight: var(--fw-bold);\n  box-shadow: 0 8px 20px -6px rgba(14, 165, 233, 0.5);\n\n  @media (max-width: 600px) {\n    width: 44px;\n    height: 44px;\n    font-size: 18px;\n  }\n}\n\n.stepBody {\n  min-width: 0;\n}\n\n.stepTitle {\n  font-size: 20px;\n  font-weight: var(--fw-bold);\n  color: var(--color-text);\n  margin: 0 0 var(--sp-2);\n  letter-spacing: -0.01em;\n}\n\n.stepDesc {\n  font-size: 16px;\n  line-height: 1.65;\n  color: var(--color-text-muted);\n  margin: 0 0 var(--sp-4);\n\n  &:last-child { margin-bottom: 0; }\n}\n\n// ---------- Command block (refreshed copy-on-click code card) ----------\n.commandBlock {\n  background:\n    linear-gradient(180deg, #0F172A 0%, #0B1120 100%);\n  border: 1px solid #1E293B;\n  border-radius: var(--radius-lg);\n  padding: var(--sp-4) var(--sp-5);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--sp-4);\n  margin: var(--sp-3) 0;\n  position: relative;\n  transition: border-color var(--duration-base) var(--easing-standard);\n\n  &:hover {\n    border-color: rgba(56, 189, 248, 0.5);\n  }\n\n  code {\n    flex: 1;\n    color: #E2E8F0;\n    font-family: var(--font-mono);\n    font-size: 15px;\n    line-height: 1.5;\n    white-space: pre-wrap;\n    word-break: break-all;\n    background: none;\n    padding: 0;\n  }\n\n  &::before {\n    content: '$';\n    color: #38BDF8;\n    font-family: var(--font-mono);\n    font-size: 15px;\n    font-weight: var(--fw-bold);\n    margin-right: var(--sp-1);\n  }\n}\n\n.commandBlockLarge {\n  align-items: stretch;\n  padding: var(--sp-5);\n\n  &::before { display: none; }\n\n  code {\n    display: block;\n    white-space: pre;\n    overflow-x: auto;\n    font-size: 14px;\n  }\n}\n\n.copyButton {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background: rgba(255, 255, 255, 0.06);\n  color: #94A3B8;\n  border-radius: var(--radius-md);\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: background var(--duration-base) var(--easing-standard),\n              color var(--duration-base) var(--easing-standard),\n              border-color var(--duration-base) var(--easing-standard);\n  position: relative;\n\n  &:hover {\n    background: rgba(56, 189, 248, 0.15);\n    border-color: rgba(56, 189, 248, 0.5);\n    color: #38BDF8;\n  }\n\n  svg {\n    width: 18px;\n    height: 18px;\n    fill: none;\n    stroke: currentColor;\n    stroke-width: 32px;\n  }\n\n  &.copied {\n    background: rgba(16, 185, 129, 0.18);\n    border-color: rgba(16, 185, 129, 0.5);\n    color: #10B981;\n\n    &::after {\n      content: 'Copied';\n      position: absolute;\n      bottom: calc(100% + 6px);\n      right: 0;\n      padding: 4px 10px;\n      background: #0F172A;\n      color: #E2E8F0;\n      font-size: 12px;\n      font-family: var(--font-sans);\n      border-radius: var(--radius-md);\n      white-space: nowrap;\n      box-shadow: var(--shadow-md);\n    }\n  }\n}\n\n// ---------- Callout / OS support box ----------\n.callout {\n  padding: var(--sp-5);\n  border-radius: var(--radius-lg);\n  border: 1px solid var(--color-border);\n  background-color: var(--color-bg);\n  margin: var(--sp-4) 0;\n  font-size: 16px;\n  line-height: 1.65;\n  color: var(--color-text-muted);\n\n  strong { color: var(--color-text); }\n\n  // 다크 모드에서 slate-100 strong은 muted 본문(slate-300대)과 대비가 약해서\n  // 굵게 해도 잘 안 띔. brand sky로 한 단계 더 또렷하게 강조. 라이트는 유지.\n  [data-theme=\"dark\"] & strong {\n    color: #7DD3FC; // sky-300\n  }\n}\n\n.calloutBrand {\n  background: linear-gradient(135deg, var(--color-primary-soft) 0%, #F5F3FF 100%);\n  border-color: rgba(14, 165, 233, 0.35);\n  color: var(--color-text);\n\n  // 다크 모드에선 우측 끝의 #F5F3FF(violet-50)가 그대로 흰색으로 남아 텍스트가\n  // 가려짐. 양쪽 모두 어두운 sky/violet 틴트 그라데이션으로 바꿔 본문이 살게.\n  [data-theme=\"dark\"] & {\n    background: linear-gradient(135deg, rgba(56, 189, 248, 0.18) 0%, rgba(139, 92, 246, 0.18) 100%);\n    border-color: rgba(56, 189, 248, 0.35);\n  }\n}\n\n// ---------- Pill list (output formats / report contents) ----------\n.pillGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: var(--sp-3);\n  margin-top: var(--sp-4);\n}\n\n.pillCard {\n  display: flex;\n  align-items: center;\n  gap: var(--sp-3);\n  padding: var(--sp-4);\n  background-color: var(--color-bg);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-lg);\n  transition: border-color var(--duration-base) var(--easing-standard),\n              box-shadow var(--duration-base) var(--easing-standard);\n\n  &:hover {\n    border-color: rgba(14, 165, 233, 0.35);\n    box-shadow: var(--shadow-sm);\n  }\n\n  svg {\n    color: var(--color-primary);\n    font-size: 22px !important;\n    width: 22px !important;\n    height: 22px !important;\n    flex-shrink: 0;\n  }\n}\n\n.pillLabel {\n  font-size: 15px;\n  font-weight: var(--fw-medium);\n  color: var(--color-text);\n}\n\n// ---------- Closing CTA ----------\n.closing {\n  margin-top: var(--sp-16);\n  padding: 0 var(--sp-10);\n\n  @media (max-width: 600px) {\n    padding: 0 var(--sp-5);\n  }\n}\n\n.closingBox {\n  // Light closing CTA card — matches the hero treatment so the page open and\n  // close share the same palette. Brand color now lives on the inner button\n  // (.btnPrimary), not on a full slate-900 slab.\n  max-width: 1100px;\n  margin: 0 auto;\n  padding: var(--sp-12) var(--sp-10);\n  background:\n    radial-gradient(ellipse at 30% 40%, rgba(14, 165, 233, 0.08) 0%, transparent 60%),\n    radial-gradient(ellipse at 70% 60%, rgba(139, 92, 246, 0.08) 0%, transparent 60%),\n    linear-gradient(135deg, #FFFFFF 0%, var(--color-bg-subtle) 100%);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-2xl);\n  text-align: center;\n  color: var(--color-text);\n  box-shadow: var(--shadow-sm);\n\n  h2 {\n    font-size: 32px;\n    font-weight: var(--fw-bold);\n    margin: 0 0 var(--sp-3);\n    letter-spacing: -0.01em;\n    color: var(--color-text);\n  }\n\n  p {\n    font-size: 16px;\n    line-height: 1.65;\n    color: var(--color-text-muted);\n    margin: 0 auto var(--sp-6);\n    max-width: 560px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `_shared_page__GtjvJ`,
	"hero": `_shared_hero__x3MN8`,
	"heroGridOverlay": `_shared_heroGridOverlay__Lm5sx`,
	"heroInner": `_shared_heroInner__yhSjb`,
	"eyebrow": `_shared_eyebrow__EkFBV`,
	"heroTitle": `_shared_heroTitle__ALqY2`,
	"brandGradient": `_shared_brandGradient__51lej`,
	"heroSubtitle": `_shared_heroSubtitle__wDkQR`,
	"heroActions": `_shared_heroActions__m5r+K`,
	"heroBadge": `_shared_heroBadge__ahGJr`,
	"btnPrimary": `_shared_btnPrimary__P6Rqg`,
	"btnSecondary": `_shared_btnSecondary__QEe1b`,
	"section": `_shared_section__ZBpRn`,
	"sectionHeader": `_shared_sectionHeader__xYkce`,
	"sectionEyebrow": `_shared_sectionEyebrow__eo-NX`,
	"sectionTitle": `_shared_sectionTitle__ocOTW`,
	"sectionLead": `_shared_sectionLead__Ag4ay`,
	"featureGrid": `_shared_featureGrid__l0uYB`,
	"featureCard": `_shared_featureCard__8oM4A`,
	"featureIcon": `_shared_featureIcon__YvGnb`,
	"featureTag": `_shared_featureTag__PhJLG`,
	"featureTitle": `_shared_featureTitle__bMMgN`,
	"featureDesc": `_shared_featureDesc__1S2Q9`,
	"featureBullets": `_shared_featureBullets__vV-UV`,
	"benefitGrid": `_shared_benefitGrid__5914P`,
	"benefitCard": `_shared_benefitCard__gTDNH`,
	"benefitIcon": `_shared_benefitIcon__qXZO7`,
	"benefitTitle": `_shared_benefitTitle__pqn48`,
	"benefitDesc": `_shared_benefitDesc__QDqE5`,
	"chipGroup": `_shared_chipGroup__AupSw`,
	"chip": `_shared_chip__0yQuG`,
	"chipBrand": `_shared_chipBrand__YQjgx`,
	"stepList": `_shared_stepList__ZyfXg`,
	"step": `_shared_step__mdJA5`,
	"stepNumber": `_shared_stepNumber__0Bn1M`,
	"stepBody": `_shared_stepBody__iLbFM`,
	"stepTitle": `_shared_stepTitle__e-NdJ`,
	"stepDesc": `_shared_stepDesc__Rc3aF`,
	"commandBlock": `_shared_commandBlock__QQn4W`,
	"commandBlockLarge": `_shared_commandBlockLarge__wUfS-`,
	"copyButton": `_shared_copyButton__U5dS5`,
	"copied": `_shared_copied__b-Qrv`,
	"callout": `_shared_callout__Pke7-`,
	"calloutBrand": `_shared_calloutBrand__MZkwH`,
	"pillGrid": `_shared_pillGrid__vdEp0`,
	"pillCard": `_shared_pillCard__b6GRt`,
	"pillLabel": `_shared_pillLabel__NK1ZY`,
	"closing": `_shared_closing__0N4k9`,
	"closingBox": `_shared_closingBox__-zdE7`
};
export default ___CSS_LOADER_EXPORT___;
